import axios from "src/lib/axios";

/**
 *
 * @param {Date} fromDate - YYYY-MM-DD
 * @param {Date} toDate - YYYY-MM-DD
 * @param {String} keyword
 * @param {String} type - all, product, bill, delivery
 * @returns
 */
export const findAllPromoCode = async ({
  fromDate = null,
  toDate = null,
  keyword = "",
  type = "",
  page = 0,
  page_size = 10,
}) => {
  const { data: response } = await axios.get(`/promocodes`, {
    params: {
      fromDate,
      toDate,
      keyword,
      type,
      page,
      page_size,
    },
  });
  return response.data;
};

/**
 *
 * @param {ObjectId} id
 * @returns
 */
export const findOnePromoCode = async (id) => {
  const { data: response } = await axios.get(`/promocode/detail/${id}`);
  return response.data;
};

/**
 *
 * @returns All deal group for filter
 */
export const findAllDealGroup = async () => {
  const { data: response } = await axios.get(`/promocodes/all-deal`);
  return response.data;
};

/**
 *
 * @returns get all promocode user can use
 */
export const getPromoCodeList = async () => {
  const { data: response } = await axios.get(`/promocodes/user`);
  return response.data;
};

/**
 *
 * @param {Object} data
 * @param {String} data.promo_name
 * @param {String} data.promo_code
 * @param {String} data.promo_type - product, bill, delivery
 * @param {Object} data.promo_condition
 * @param {String} data.promo_condition.promo_condition_user - all, new, repeat
 * @param {Boolean} data.promo_condition.promo_condition_repeat
 * @param {String} data.promo_product_group - ready, pre-order, all
 * @param {String} data.promo_pay_type
 * @param {Object} data.promo_discount
 * @param {String} data.promo_discount.promo_discount_type - percent, amount
 * @param {Number} data.promo_discount.promo_discount_value
 * @param {Number} data.promo_discount.promo_discount_percent
 * @param {Number} data.promo_discount.promo_discount_minimum_spend
 * @param {Number} data.promo_discount.promo_discount_maximum
 * @param {Object} data.promo_responsible
 * @param {String} data.promo_responsible.promo_responsible_by - xsurface, seller, split
 * @param {Number} data.promo_responsible.promo_xsurface_percent
 * @param {Number} data.promo_responsible.promo_seller_percent
 * @param {Date} data.promo_start_time
 * @param {Date} data.promo_expire_time
 * @param {Number} data.amount
 * @param {Number} data.used_amount
 * @param {String} data.promo_title
 * @param {String} data.promo_description
 * @param {ObjectId[]} data.product_choice_promocodes
 * @param {String} data.note
 * @returns
 */
export const createPromoCode = async (data) => {
  const { data: response } = await axios.post(`/promocode`, data);
  return response.data;
};

/**
 *
 * @param {Object} data
 * @param {ObjectId} data._id
 * @param {String} data.promo_name
 * @param {String} data.promo_code
 * @param {String} data.promo_type - product, bill, delivery
 * @param {Object} data.promo_condition
 * @param {String} data.promo_condition.promo_condition_user - all, new, repeat
 * @param {Boolean} data.promo_condition.promo_condition_repeat
 * @param {String} data.promo_product_group - ready, pre-order, all
 * @param {String} data.promo_pay_type
 * @param {Object} data.promo_discount
 * @param {String} data.promo_discount.promo_discount_type - percent, amount
 * @param {Number} data.promo_discount.promo_discount_value
 * @param {Number} data.promo_discount.promo_discount_percent
 * @param {Number} data.promo_discount.promo_discount_minimum_spend
 * @param {Number} data.promo_discount.promo_discount_maximum
 * @param {Object} data.promo_responsible
 * @param {String} data.promo_responsible.promo_responsible_by - xsurface, seller, split
 * @param {Number} data.promo_responsible.promo_xsurface_percent
 * @param {Number} data.promo_responsible.promo_seller_percent
 * @param {Date} data.promo_start_time
 * @param {Date} data.promo_expire_time
 * @param {Number} data.amount
 * @param {Number} data.used_amount
 * @param {String} data.promo_title
 * @param {String} data.promo_description
 * @param {ObjectId[]} data.product_choice_promocodes
 * @param {String} data.note
 * @returns
 */
export const updatePromoCode = async (data) => {
  const { data: response } = await axios.patch(`/promocode`, data);
  return response.data;
};

/**
 *
 * @param {ObjectId} id
 * @returns
 */
export const updateStatusPromoCode = async (id) => {
  const { data: response } = await axios.patch(
    `/promocode/hidden-or-show/${id}`,
  );
  return response.data;
};

/**
 *
 * @param {ObjectId} id
 * @returns
 */
export const deletePromoCode = async (id) => {
  const { data: response } = await axios.delete(`/promocode/${id}`);
  return response.data;
};
